import apiClient from '../client/api';

export type GetConditionResponse = {
  id: string;
  name: string;
  about: Array<string>;
  avgAgeOnset: string;
  fiveYearSurvivalRate: string;
};

async function getCondition(conditionId: string): Promise<GetConditionResponse> {
  const res = await apiClient.get(`/conditions/${conditionId}`);
  return res.data;
}

export default { getCondition };
